module.exports = __webpack_public_path__ + "d813f12d3928ab37718af845f7acc892.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/RoundedMplus1c-Medium.ttf
// module id = 23
// module chunks = 0